import upload from '@/services/upload'
import createFileName from './../dataMapping/createFileName'

const UploadThumbnail = async (imageFile, state, index) => {
  
  let blob = await fetch(imageFile).then(r => r.blob());
  let dataUrl = await new Promise(resolve => {
    let reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

  return new Promise((resolve, reject) => {
    const fileName = createFileName(state.product, 'png', `section-${index}`)

    upload({
      file: dataUrl,
      fileName: fileName,
      folderName: 'section_thumbnails',
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default UploadThumbnail
